{
  "version": 1,
  "asset_id": "4f7aadde-72f4-4dc0-b305-ae8cb5c18b2a",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/4f7aadde-72f4-4dc0-b305-ae8cb5c18b2a/g26.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/4f7aadde-72f4-4dc0-b305-ae8cb5c18b2a/g26.jpg",
  "original_filename": "g26.jpg",
  "size": 110401,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T23:00:11Z"
}
